module.exports = __webpack_public_path__ + "static/media/tweet.5ece60ee.png";